const gmtOffSetFunc = () => {
    const date = new Date();
    const offset = -date.getTimezoneOffset();
    const sign = offset >= 0 ? '+' : '-';
    const absOffset = Math.abs(offset);
    const hours = String(Math.floor(absOffset / 60)).padStart(2, '0');
    const minutes = String(absOffset % 60).padStart(2, '0');
    const gmtOffset = `${sign}${hours}:${minutes}`;
    return gmtOffset
}

const formattedGridList = (newGridList) => {
    const dateObj = new Date(newGridList.date);
    const year = dateObj.getFullYear();
    const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
    const day = dateObj.getDate().toString().padStart(2, '0');
    return {
        ...newGridList,
        date: `${year}-${month}-${day}`
    };
};

export const updateLinearSchedule = async (
    setLoaderStatus,
    gridList,
    locationState,
    Schedule_update_weekly,
    toast,
    today,
    newGridData,
    fetchDataByDate
) => {
    setLoaderStatus(true);
    let originalGridList = gridList.find((item) => item?.date === locationState?.state?.panelDate);
    let newGridList = newGridData?.find((item) => item?.date === locationState?.state?.panelDate);

    let formattedList = formattedGridList(newGridList);
    let originalFormattedGridList = formattedGridList(originalGridList);

    const draft = [];
    const publish = [];
    const MILLISECONDS_IN_24_HOURS = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

    if (formattedList) {
        const totalDuration = formattedList.scheduleItems.reduce(
            (sum, item) => sum + item.totalDuration,
            0
        );

        if (totalDuration >= MILLISECONDS_IN_24_HOURS) {
            publish.push(formattedList.date);
        } else {
            draft.push(formattedList.date);
        }
    }

    let draftData = [];
    let publishData = [];

    if (originalFormattedGridList) {
        if (draft.includes(originalFormattedGridList.date)) {
            draftData.push(originalFormattedGridList);
        }
        if (publish.includes(originalFormattedGridList.date)) {
            publishData.push(originalFormattedGridList);
        }
    }

    let payload = {
        timeOffset: gmtOffSetFunc(),
        draft: draftData,
        publish: publishData
    };

    const response = await Schedule_update_weekly(payload, locationState?.state?.channelId);
    
    if (response) {
        toast.success("Channel Updated successfully", {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000
        });
        // today();
        fetchDataByDate();
        setLoaderStatus(false);
    } else {
        toast.error("Channel Update failed", {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000
        });
        setLoaderStatus(false);
    }
}